import { ClassConstructor } from "class-transformer";
import { snakeCase } from "lodash";
import VueI18n from "vue-i18n";

import { VueComponent } from "../../../../../shared/types/VueComponent";
import { PostActionTypeEnum } from "../../types";
import { PostActionStructure } from "./PostActionStructure";

export type TranslationKeyData = { key: string, params?: VueI18n.Values }

export abstract class PostActionBuilder {
  actionProps: (() => Record<string, any>) | undefined

  abstract type: PostActionTypeEnum | string
  abstract view: VueComponent | undefined
  abstract valueView: VueComponent | undefined
  abstract createAction(constructor: ClassConstructor<PostActionStructure>): PostActionStructure

  /**
   * material icon
   **/
  abstract icon: string

  /**
   * флаг, чтобы отметить карточку действия красным, как устаревшее. к нему настраивается опциональный ключ с текстом
   **/
  isDeprecated = false

  /**
   * флаг, чтобы скрыть карточку в списке действий, но при этом, оставить возможность настраивать его
   **/
  isVisible = true

  isDisabled() {
    return false
  }

  snakeCaseType() {
    return snakeCase(this.type)
  }

  disabledMessage(): TranslationKeyData {
    return {
      key: `post_action_${ this.snakeCaseType() }_disabled`
    }
  }

  deprecatedMessage(): TranslationKeyData {
    return {
      key: `post_action_${ this.snakeCaseType() }_deprecated`
    }
  }

  actionTitle(): TranslationKeyData {
    return {
      key: `post_action_${ this.snakeCaseType() }`
    }
  }

  actionHelpMessage(): TranslationKeyData {
    return {
      key: `post_action_${ this.snakeCaseType() }_help_message`
    }
  }
}
